import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useVoipRoomStore } from '@stores/voip-room'

import { useRoomLiveKit } from '@hooks/classroom/room-live-kit.hook'

interface ClassroomJoiningReturn {
  isJoining: ComputedRef<boolean>
}

export const useClassroomJoining = (): ClassroomJoiningReturn => {
  const voipRoomStore = useVoipRoomStore()
  const { connectionState, isSupported } = useRoomLiveKit()

  const isConnectionPending = computed<boolean>(() =>
    connectionState.value === 'idle' || connectionState.value === 'connecting',
  )

  const isJoining = computed<boolean>(() =>
    !voipRoomStore.isAlternativeVoip && isSupported && isConnectionPending.value,
  )

  return { isJoining }
}
